import axios from 'axios';
import { config } from 'environment/config';

export const axiosBaseInstance = axios.create({
  baseURL: config.serverBaseUrl,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const axiosUnauthenticatedInstance = axios.create({
  baseURL: config.serverBaseUrl,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const axiosGuestSmartAssistantInstance = axios.create({
  baseURL: config.serverBaseUrl,
  headers: {
    'Content-Type': 'application/json'
  }
});
